import { countActiveVariantsForComponent } from "./countActiveVariantsForComponent";
import type { ComponentStoreData } from "./types";

/**
 * Calculate the number of combinations from component store data.
 * This is the cartesian product of non-empty values across all components.
 */
export const calculateCombinationCount = (componentStoreData: ComponentStoreData | undefined): number => {
  if (!componentStoreData || !componentStoreData.components) {
    return 0;
  }

  const components = componentStoreData.components;
  const deactivatedValuesByComponent = componentStoreData.deactivatedValues ?? {};
  const componentNames = Object.keys(components);

  if (componentNames.length === 0) {
    return 0;
  }

  let totalCombinations = 0;
  for (const componentName of componentNames) {
    const componentValues = components[componentName] || [];
    const count = countActiveVariantsForComponent(componentValues, deactivatedValuesByComponent[componentName]);

    if (count > 0) {
      if (totalCombinations === 0) {
        totalCombinations = 1;
      }

      totalCombinations *= count;
    }
  }

  return totalCombinations;
};
